type LoadError = { code?: string; message?: string };

export class ConversationLoadRequestError extends Error {
  readonly resource: string;
  readonly operation: string;
  readonly code: string | undefined;

  constructor(resource: string, operation: string, error: LoadError) {
    super(error.message || 'Request failed');
    this.name = 'ConversationLoadRequestError';
    this.resource = resource;
    this.operation = operation;
    this.code = error.code;
  }
}

export function throwIfConversationLoadError(error: LoadError | null, resource: string, operation: string): void {
  if (error) throw new ConversationLoadRequestError(resource, operation, error);
}

export function handleConversationLoadFailure({
  error,
  development,
  clearLoading,
  log,
  toast,
  navigate,
}: {
  error: unknown;
  development: boolean;
  clearLoading: () => void;
  log: (message: string, details: Record<string, string | undefined>) => void;
  toast: (options: { title: string; description: string; variant: 'destructive' }) => void;
  navigate: (path: string) => void;
}): void {
  const request = error instanceof ConversationLoadRequestError ? error : null;
  log('Conversation load failed', {
    resource: request?.resource,
    operation: request?.operation,
    code: request?.code,
    message: request?.message ?? 'Unexpected conversation load error',
  });
  clearLoading();
  toast({
    title: 'Error',
    description: development && request
      ? `Failed to load conversation (${request.resource}${request.code ? `: ${request.code}` : ''}).`
      : 'Failed to load conversation. Please try again.',
    variant: 'destructive',
  });
  navigate('/');
}
